export const ua = ((navigator && navigator.userAgent) || '').toLowerCase();

export const isJD = /jdapp/i.test(ua); // 是否是京东app

export const isJDJR = /jdjr-app/i.test(ua); // 是否是京东金融
